import { ErrorBoundary, ErrorBoundaryProps } from '@sentry/react'
import React from 'react'

import FullPageErrorFallback from './FullPageErrorFallback'

type Props = ErrorBoundaryProps

export const SentryErrorBoundary: React.FC<Props> = (props) => {
  return (
    <ErrorBoundary
      fallback={(error) => <FullPageErrorFallback error={error} />}
      {...props}
    />
  )
}
